
export enum CouponCd {
	CAP_AT_VSP = 'CapAtVsp',
	DEFAULT_DISCOUNT = 'DefaultDiscount',
	LINEAL_FOOT = 'LinealFoot',
	PALLET_WEIGHT_EXCLUDE = 'PalletWeightExclude',
	PALLET_WEIGHT_INCLUDE = 'PalletWeightInclude'}

